import { Alert, Linking, Platform } from 'react-native';
import { i18n } from '@/common/i18n';
import Constants from 'expo-constants';
import * as Device from 'expo-device';
import * as Notifications from 'expo-notifications';
import { StorageService } from '../storage/storage.service';

const registerForPushNotificationsAsync = async () => {
  try {
    let token;

    if (Platform.OS === 'android') {
      await Notifications.setNotificationChannelAsync('myNotificationChannel', {
        name: 'A channel is needed for the permissions prompt to appear',
        importance: Notifications.AndroidImportance.MAX,
        vibrationPattern: [0, 250, 250, 250],
        lightColor: '#FF231F7C',
      });
    }

    if (Device.isDevice) {
      const { status: existingStatus } =
        await Notifications.getPermissionsAsync();
      let finalStatus = existingStatus;
      if (existingStatus !== 'granted') {
        const { status } = await Notifications.requestPermissionsAsync();
        finalStatus = status;
      }
      if (finalStatus !== 'granted') {
        Alert.alert(
          i18n.t('notifications.activation.error_title'),
          i18n.t('notifications.activation.failed'),
          [
            { text: i18n.t('general.labels.ok'), onPress: () => {} },
            {
              text: i18n.t('general.labels.go_to_settings'),
              onPress: () => Linking.openSettings(),
            },
          ]
        );
        return;
      }

      // Learn more about projectId:
      // https://docs.expo.dev/push-notifications/push-notifications-setup/#configure-projectid
      // EAS projectId is used here.
      try {
        const projectId =
          Constants?.expoConfig?.extra?.eas?.projectId ??
          Constants?.easConfig?.projectId;
        if (!projectId) {
          throw new Error('Project ID not found');
        }
        token = (
          await Notifications.getExpoPushTokenAsync({
            projectId,
          })
        ).data;
        console.log('push token: ', token);
        // TODO: Send token to backend - check NotificationsService.registerFcmToken from cockpit project
      } catch (e) {
        console.log(`catch getExpoPushTokenAsync: ${e}`);
        token = `${e}`;
      }
    }

    return token;
  } catch (e) {
    console.log('error: ', e);
    return null;
  }
};

const unregisterForPushNotificationsAsync = async () => {
  // TODO: Missing endpoint to remove token from backend
  if (Platform.OS !== 'web') {
    await StorageService.clearNotificationToken();
    await Notifications.unregisterForNotificationsAsync();
  }
};

export const NotificationsService = {
  registerForPushNotificationsAsync,
  unregisterForPushNotificationsAsync,
};
